// 1. Definir la variable global antes que cualquier otra cosa
(window as any).ngDevMode = (window as any).ngDevMode || false;
import('./bootstrap')
	.catch(err => console.error(err));
